<header id="header">
    <mat-toolbar>
        <div class="left-block" [ngClass]="{
            'background': !sideNavClose
        }">
            <button mat-icon-button (click)="onSideNavToggle()">
                <mat-icon svgIcon="menu_icon"></mat-icon>
            </button>

            <span class="restaurant-picture">
                <img class="profile-pic" src="/assets/images/tapgo-logo.svg" />
                <mat-chip-list class="title status">
                    <mat-chip class="small opacity" *ngIf="!mobileMode">
                        <span class="opacity-7">{{ 'PORTAL' | translate }}</span>
                    </mat-chip>
                </mat-chip-list>
            </span>
        </div>

        <a [href]="customerPanelUrl" rel="noopener noreferrer" target="_blank" class="preview-btn il ml-3"
            *ngIf="!mobileMode" color="primary" mat-stroked-button>
            <mat-icon class="flex" svgIcon="eye_icon"></mat-icon>
            {{ 'PREVIEW_STORE' | translate }}
        </a>
        <span class="spacer"></span>
        <app-language-switcher></app-language-switcher>
        <!-- <button mat-button id="olvy-target" *ngIf="!mobileMode">
            <mat-icon svgIcon="flag_icon"></mat-icon>
            {{ 'WHATS_NEW' | translate }}
        </button> -->

        <app-theme-switch #tooltip="matTooltip"
            matTooltip="{{theme.endsWith('dark-theme') ? ('LIGHT_MODE' | translate) : ('DARK_MODE' | translate) }}"
            [matTooltipPosition]="'below'" class="ml-3"></app-theme-switch>

        <button color="primary" *ngIf="!mobileMode" mat-icon-button matTooltip="{{ 'SELECT_THEME' | translate }}"
            [matMenuTriggerFor]="themeMenu" class="ml-3">
            <mat-icon svgIcon="paint_bucket_icon"></mat-icon>
        </button>

        <button mat-icon-button matTooltip="{{ 'NOTIFICATIONS' | translate }}" [matMenuTriggerFor]="notification"
            color="primary" class="ml-3">
            <mat-icon [matBadge]="unreadNotificationCount" matBadgePosition="after" matBadgeOverlap="true"
                matBadgeSize="small" matBadgeColor="warn" svgIcon="bell_icon"></mat-icon>
        </button>
        <button mat-icon-button [matMenuTriggerFor]="menu" class="ml-3">
            <figure class="profile-pic">
                <img [src]="profile?.profileImageLink ? (S3_URL+''+BUCKET_NAME+'/'+profile.profileImageLink) : '/assets/images/avatar.svg'"
                    alt="">
            </figure>
        </button>

    </mat-toolbar>

    <!-- profile menu -->
    <mat-menu #menu="matMenu" xPosition="before" class="menu">
        <button mat-menu-item routerLink="profile">
            <mat-icon>person</mat-icon>
            <span>{{ 'PROFILE' | translate }}</span>
        </button>
        <button mat-menu-item (click)="logout()">
            <mat-icon>power_settings_new</mat-icon>
            <span>{{ 'LOG_OUT' | translate }}</span>
        </button>
    </mat-menu>

    <!-- notification menu -->
    <mat-menu #notification="matMenu" xPosition="before" class="menu custom-scrollbar notification-menu">
        <app-notification-menu [markAllRead]="markAllRead" (unreadCount)="getUnreadCount($event)">
        </app-notification-menu>
    </mat-menu>

    <!-- theme menu -->
    <mat-menu #themeMenu="matMenu" xPosition="before" class="menu">
        <button mat-menu-item role="menuitemradio" aria-checked="true" *ngFor="let theme of themeList"
            (click)="selectTheme(theme)">
            <mat-icon color="accent">{{selectedTheme?.name === theme.name ? 'radio_button_checked' :
                'radio_button_unchecked'}}</mat-icon><span>{{ theme.name }}</span>
        </button>
    </mat-menu>
</header>